import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import Store from '../types/store'
import baseQueryWithAuth from "./baseQuery";

export interface AddToMyStoresRequest {
  storeId: string
}

export const storeApi = createApi({
  reducerPath: 'storeApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['MyStores'],
  endpoints: (builder) => ({
    getStoreById: builder.query<Store, string>({
      query: (storeId) => ({
        url: `https://get-store-by-id.gyore-soma.workers.dev/${storeId}`,
      }),
    }),
    getAllStores: builder.query<Store[], void>({
      query: () => ({
        url: 'https://get-all-stores.gyore-soma.workers.dev/',
      }),
    }),
    getMyStores: builder.query<Store[], void>({
      query: () => ({
        url: 'https://get-my-stores.gyore-soma.workers.dev/',
      }),
      providesTags: ['MyStores'],
    }),
    addToMyStores: builder.mutation<void, AddToMyStoresRequest>({
      query: (payload) => ({
        url: 'https://add-to-my-stores.gyore-soma.workers.dev/',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['MyStores'],
    }),
    removeFromMyStores: builder.mutation<void, string>({
      query: (storeId) => ({
        url: `https://delete-from-my-stores.gyore-soma.workers.dev/${storeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['MyStores'],
    }),
  }),
})

export const {
  useGetStoreByIdQuery,
  useRemoveFromMyStoresMutation,
  useGetAllStoresQuery,
  useGetMyStoresQuery,
  useAddToMyStoresMutation,
} = storeApi
